import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import TableChartOptions from "../../csi/middleware/customView/options/TableChartOptions";
import TablePrintOptions from "../../csi/middleware/customView/options/TablePrintOptions";
import TableViewOptions from "../../csi/middleware/customView/options/TableViewOptions";
import SizeChartTableViewOptions from "./SizeChartTableViewOptions";

const SizeChartTableOptionsTab: FunctionComponent = function SizeChartTableOptionsTab() {
	return (
		<FlexRowCenter>
			<FlexColumn 
				data-csi-automation="SizeChartTableOptionsTab"
				width="100%"
			>
				<SizeChartTableViewOptions />
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = SizeChartTableOptionsTab;